(() => {
  const start = () => {
    document.querySelectorAll('[data-vault-countdown]').forEach(timer => {
      if (timer.dataset.ready) return;
      timer.dataset.ready = 'true';
      const end = Date.parse(timer.dataset.end);
      if (!Number.isFinite(end)) { timer.hidden = true; return; }
      const draw = () => {
        const remaining = Math.max(0, end - Date.now());
        const seconds = Math.floor(remaining / 1000);
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        Object.entries(values).forEach(([key,value]) => { const element = timer.querySelector(`[data-count="${key}"]`); if(element) element.textContent = String(value).padStart(2, '0'); });
        if (remaining === 0) { timer.querySelector('[data-count-title]').textContent = 'Public access date has arrived'; timer.setAttribute('aria-label', 'Public access date has arrived: November 9, 2026'); }
      };
      draw();
      const interval = window.setInterval(() => { if (!timer.isConnected) { window.clearInterval(interval); return; } draw(); }, 1000);
    });
  };
  start();
  document.addEventListener('shopify:section:load', start);
})();
